/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '@dm/core';
import { SWITCH } from 'app/config';

@Component({
    selector: 'app-check-toast',
    templateUrl: './check-toast.component.html',
    styleUrls: ['./check-toast.component.scss'],
})
export class CheckToastComponent {
    @Output() onClose = new EventEmitter<void>();

    get = this.i18nService.get;

    i18n = {
        /**
         * 发现新版本
         */
        newVersion: this.get('settings.upgrade_task_findNewVersion_info'),
        /**
         * 立即查看
         */
        check: this.get('settings.upgrade_task_checkNow_info'),
    };

    constructor(
        private i18nService: I18nService,
        private router: Router,
    ) { }

    jump(): void {
        // 极简场景 跳转至极简设置  并打开升级页签 进行配置
        if (SWITCH.IS_SIMPLE_MODE) {
            this.router.navigate(['/simple/settings'], {
                queryParams: {
                    action: 'simpleModeOpenUpgrade',
                },
            });
        } else {
            this.router.navigate(['/settings/basic-infomation/upgrade']);
        }
        this.onClose.emit();
    }
}
